<template>
  <ValidationProvider
    v-slot="{ errors, required }"
    :ref="refName"
    :vid="name"
    :name="name"
    :rules="rules"
    tag="div"
    class="text-field">
    <div
      :class="[
        'text-field-wrap w-full flex bg-white p-3 rounded-lg',
        { 'text-field-error': !!errors && Array.isArray(errors) && !!errors[0] }
      ]">
      <div class="text-field__slot-prepend">
        <slot
          name="prepend"
          v-bind="{ name, errors }">
          <label
            v-if="label"
            :for="name">
            {{ label }}
          </label>
        </slot>
      </div>
      <div class="text-field__slot-default w-full">
        <slot v-bind="{ name, errors }">
          <div class="text-field-input flex">
            <slot
              name="input"
              v-bind="{ name, errors }">
              <input
                v-model="innerValue"
                v-bind="$attrs"
                :name="name"
                :type="type"
                :required="required"
                :disabled="disabled"
                :class="[inputClass]">
            </slot>
          </div>
        </slot>
      </div>
      <div class="text-field__slot-append">
        <slot
          name="append"
          v-bind="{ name, errors }">
        </slot>
      </div>
    </div>
    <div :class="['text-field-messages', { 'text-messages-error': !!errors && Array.isArray(errors) && !!errors[0] }]">
      <span>{{ errors[0] }}</span>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'FormTextField',
  props: {
    rules: {
      type: [String, Object],
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    name: {
      type: String,
      required: true,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    inputClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    type () {
      return this.$attrs?.type || 'text'
    },
    refName () {
      return `validation-provider-${this.name}`
    }
  }
}
</script>

<style lang="postcss" scoped>
input {
  width: 100%;
  padding: 3px 5px;
  color: #000;
  background-color: #ffffff;
}
input:focus-visible {
  outline: none;
}
.text-field-wrap {
  color: #000;
  transition: color 0.25s;
}
.text-messages-error {
  color: var(--color-danger);
}
.text-field-error input {
  border-color: var(--color-danger);
}
.text-field-messages {
  font-size: 12px;
  height: 18px;
}
input[disabled] {
  background-color: #ece9e9;
  cursor: not-allowed;
}
</style>
